Object.defineProperty(exports,"__esModule",{value:true});exports.voronoiContainerMixin=undefined;var _defaults2=require("lodash/defaults");var _defaults3=_interopRequireDefault(_defaults2);var _omit2=require("lodash/omit");var _omit3=_interopRequireDefault(_omit2);var _this2=this;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=require("react");var _react2=_interopRequireDefault(_react);
var _victoryCore=require("victory-core");
var _voronoiHelpers=require("./voronoi-helpers");var _voronoiHelpers2=_interopRequireDefault(_voronoiHelpers);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}


var voronoiContainerMixin=exports.voronoiContainerMixin=function voronoiContainerMixin(base){var _class,_temp;return _temp=_class=function(_base){_inherits(VictoryVoronoiContainer,_base);function VictoryVoronoiContainer(){_classCallCheck(this,VictoryVoronoiContainer);return _possibleConstructorReturn(this,(VictoryVoronoiContainer.__proto__||Object.getPrototypeOf(VictoryVoronoiContainer)).apply(this,arguments));}_createClass(VictoryVoronoiContainer,[{key:"getLabelPadding",value:function getLabelPadding(










































style){
if(!style){
return 0;
}
var paddings=Array.isArray(style)?style.map(function(s){return s.padding;}):[style.padding];
return Math.max.apply(Math,_toConsumableArray(paddings).concat([0]));
}},{key:"getFlyoutSize",value:function getFlyoutSize(

labelComponent,text,style){
var padding=this.getLabelPadding(style);
var textSize=_victoryCore.TextSize.approximateTextSize(text,style);
return{
x:labelComponent.width||textSize.width+padding,
y:labelComponent.height||textSize.height+padding};

}},{key:"getFlyoutExtent",value:function getFlyoutExtent(

position,flyoutSize){var
x=position.x,y=position.y;
var width=flyoutSize.x/2;
var height=flyoutSize.y;
var extent={x:[x-width,x+width],y:[y-height,y]};
return{
x:[Math.min.apply(Math,_toConsumableArray(extent.x)),Math.max.apply(Math,_toConsumableArray(extent.x))],
y:[Math.min.apply(Math,_toConsumableArray(extent.y)),Math.max.apply(Math,_toConsumableArray(extent.y))]};

}},{key:"getLabelPosition",value:function getLabelPosition(

props,points,text,style){var
mousePosition=props.mousePosition,dimension=props.dimension,scale=props.scale,labelComponent=props.labelComponent,voronoiPadding=props.voronoiPadding;
var dataX=points[0]._x1!==undefined?points[0]._x1:points[0]._x;
var dataY=points[0]._y1!==undefined?points[0]._y1:points[0]._y;
var basePosition={
x:scale.x(dataX),
y:scale.y(dataY)};

if(!dimension||points.length<2){
return basePosition;
}

var x=dimension==="y"?mousePosition.x:basePosition.x;
var y=dimension==="x"?mousePosition.y:basePosition.y;
var flyoutSize=this.getFlyoutSize(labelComponent,text,style);
var range={x:scale.x.range(),y:scale.y.range()};
var extent={
x:[Math.min.apply(Math,_toConsumableArray(range.x))+voronoiPadding,Math.max.apply(Math,_toConsumableArray(range.x))-voronoiPadding],
y:[Math.min.apply(Math,_toConsumableArray(range.y))+voronoiPadding,Math.max.apply(Math,_toConsumableArray(range.y))-voronoiPadding]};

var flyoutExtent=this.getFlyoutExtent({x:x,y:y},flyoutSize);
var adjustments={
x:[
flyoutExtent.x[0]<extent.x[0]?extent.x[0]-flyoutExtent.x[0]:0,
flyoutExtent.x[1]>extent.x[1]?flyoutExtent.x[1]-extent.x[1]:0],

y:[
flyoutExtent.y[0]<extent.y[0]?extent.y[0]-flyoutExtent.y[0]:0,
flyoutExtent.y[1]>extent.y[1]?flyoutExtent.y[1]-extent.y[1]:0]};


return{
x:Math.round(x+adjustments.x[0]-adjustments.x[1]),
y:Math.round(y+adjustments.y[0]-adjustments.y[1])};

}},{key:"getStyle",value:function getStyle(

props,points,type){var
labels=props.labels,labelComponent=props.labelComponent,theme=props.theme;
var componentProps=labelComponent.props||{};
var themeStyles=theme&&theme.voronoi&&theme.voronoi.style?theme.voronoi.style:{};
var componentStyle=type==="flyout"?componentProps.flyoutStyle:componentProps.style;
var defaultStyles=(0,_defaults3.default)({},componentStyle,themeStyles[type]);
return points.reduce(function(memo,point){
var text=_victoryCore.Helpers.evaluateProp(labels,point,true);
var textArray=text?(""+text).split("\n"):[];
var baseStyle=point.style&&point.style[type]||{};
var style=_victoryCore.Helpers.evaluateStyle((0,_defaults3.default)({},baseStyle,defaultStyles),point,true);
var styleArray=textArray.length?textArray.map(function(){return style;}):[style];
memo=memo.concat(styleArray);
return memo;
},[]);
}},{key:"getDefaultLabelProps",value:function getDefaultLabelProps(

props,points){var
dimension=props.dimension;
var multiPoint=dimension&&points.length>1;
return{
orientation:multiPoint?"top":undefined,
pointerLength:multiPoint?0:undefined};

}},{key:"getLabelProps",value:function getLabelProps(

props,points){var
labels=props.labels,scale=props.scale,labelComponent=props.labelComponent,theme=props.theme;
var text=points.reduce(function(memo,point){
var t=_victoryCore.Helpers.evaluateProp(labels,point,true);
if(t===null||t===undefined){
return memo;
}
memo=memo.concat((""+t).split("\n"));
return memo;
},[]);
var style=this.getStyle(props,points,"labels");
var labelPosition=this.getLabelPosition(props,points,text,style);
return(0,_defaults3.default)(_extends({

theme:theme,style:style,text:text,scale:scale,
active:true,
renderInPortal:false,
flyoutStyle:this.getStyle(props,points,"flyout")[0],
datum:(0,_omit3.default)(points[0],["childName","style","continuous"])},
labelPosition),

labelComponent.props,
this.getDefaultLabelProps(props,points));

}},{key:"getTooltip",value:function getTooltip(

props){var
labels=props.labels,activePoints=props.activePoints,labelComponent=props.labelComponent;
if(!labels){
return null;
}
if(Array.isArray(activePoints)&&activePoints.length){
return _react2.default.cloneElement(labelComponent,this.getLabelProps(props,activePoints));
}else{
return null;
}
}},{key:"getChildren",value:function getChildren(


props){
var children=_react2.default.Children.toArray(props.children);
return[].concat(_toConsumableArray(children),[this.getTooltip(props)]).map(function(component,i){
return component?_react2.default.cloneElement(component,{key:i}):null;
});
}}]);return VictoryVoronoiContainer;}(base),_class.displayName="VictoryVoronoiContainer",_class.propTypes=_extends({},_victoryCore.VictoryContainer.propTypes,{onActivated:_react2.default.PropTypes.func,onDeactivated:_react2.default.PropTypes.func,standalone:_react2.default.PropTypes.bool,radius:_react2.default.PropTypes.number,voronoiPadding:_react2.default.PropTypes.number,labelComponent:_react2.default.PropTypes.element,labels:_react2.default.PropTypes.func,dimension:_react2.default.PropTypes.oneOf(["x","y"])}),_class.defaultProps=_extends({},_victoryCore.VictoryContainer.defaultProps,{labelComponent:_react2.default.createElement(_victoryCore.VictoryTooltip,null),voronoiPadding:5}),_class.defaultEvents=[{target:"parent",eventHandlers:{onMouseLeave:function onMouseLeave(evt,targetProps){return _voronoiHelpers2.default.onMouseLeave(evt,targetProps);},onMouseMove:function onMouseMove(evt,targetProps){var mutations=_voronoiHelpers2.default.onMouseMove(evt,targetProps);if(mutations.id!==_this2.mouseMoveMutationId){_this2.mouseMoveMutationId=mutations.id;return mutations.mutations;}}}},{target:"data",eventHandlers:{onMouseOver:function onMouseOver(){return null;},onMouseOut:function onMouseOut(){return null;},onMouseMove:function onMouseMove(){return null;}}}],_temp;};exports.default=


voronoiContainerMixin(_victoryCore.VictoryContainer);


//////////////////
// WEBPACK FOOTER
// ./~/victory-chart/lib/components/containers/victory-voronoi-container.js
// module id = 678
// module chunks = 0